import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Webhook } from '../api/useWebhookApi';

interface Props {
    webhookCreatePending: boolean;
    webhook?: Webhook;
    createWebhook: () => void;
}

export const WebhookEditor: React.FC<Props> = ({ webhookCreatePending, webhook, createWebhook }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (!webhook?.url) return;
        navigator.clipboard.writeText(webhook.url).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="flex flex-col gap-2">
            <h3 className="text-sm font-medium">Webhook</h3>
            {webhook ? (
                <div className="flex items-center gap-2 rounded-md border px-3 py-2 text-sm bg-muted/50">
                    <span className="flex-1 truncate select-all">{webhook.url}</span>
                    <button
                        type="button"
                        onClick={handleCopy}
                        className="shrink-0 text-muted-foreground hover:text-foreground transition-colors"
                        title="Copy to clipboard"
                    >
                        {copied ? <Check size={14} /> : <Copy size={14} />}
                    </button>
                </div>
            ) : null}
            <p className="text-xs text-muted-foreground">When this URL is called this node will be triggered</p>
            <Button variant="outline" size="sm" disabled={webhookCreatePending} onClick={createWebhook}>
                {webhook ? 'Recreate Webhook' : 'Create Webhook'}
            </Button>
        </div>
    );
};
